<div class="row align-items-center flex-wrap usp-row custom-height">
    <!-- <ng-container *ngFor="let member of shown_team; let i = index"> -->
        <div class="col-lg" (click)="clickJoin(member)" style="cursor: pointer;">
            <div class="card border-mint">
                <div class="member-image">
                    <img [src]="member.img" [alt]="member.name + ', ' + member.designation" [ngClass]="member.id == 0 ? 'question-mark' : ''">
                </div>
    
                <div class="text-center">
                    <p class="team-name">{{member.name}}</p>
                    <p class="team-designation">{{member.designation}}</p>
                </div>
            </div>
        </div>
    <!-- </ng-container> -->
    
            <!-- <swiper [config]="config">
                <div class="swiper-wrapper" style="overflow: visible !important;">
                    <ng-container *ngFor="let member of shown_team; let i = index">
                        <div class="swiper-slide">
                            {{member | json}}
                        </div>
                    </ng-container>
                </div>
                <div class="swiper-pagination"></div>
            </swiper> -->
</div>